import { numberFormat } from 'App/babel/components/Filters/Currencies';
import { StatusCategory } from 'App/services/prospectingService';
import Prospecting from 'App/babel/resources/Prospecting';
import RequestBuilder, { comparisonTypes } from 'Resources/RequestBuilder';
import T from 'Components/Helpers/translate';

type Filter = { value: string[]; comparisonType: keyof typeof comparisonTypes; inactive: boolean };
type RawFilter = { v: string[]; c: keyof typeof comparisonTypes; i: boolean };

const FIELD = 'stockList';

// Swedish stock exchange lists (Stockholm Large/Mid/Small Cap, First North, Spotlight). Based on
// CompanyTypeLookup, but the names are shown as the index stores them (formatName would turn
// "Large Cap" into "Large cap"), and there is no mincount, which could hide a small list.
function generateFilter(countryCode: string) {
	function generate(): Filter {
		return {
			inactive: true,
			comparisonType: 'Equals',
			value: []
		};
	}

	function isInactive(filter: Filter) {
		return filter.value.length ? false : true;
	}

	function toUrl(filter: Filter) {
		return { v: filter.value, i: filter.inactive, c: filter.comparisonType };
	}

	function fromUrl(rawFilter: RawFilter) {
		const filter = generate();

		if (rawFilter.v) {
			filter.value = rawFilter.v;
		}
		if (rawFilter.c) {
			filter.comparisonType = rawFilter.c;
		}

		filter.inactive = rawFilter.hasOwnProperty('i') ? rawFilter.i : isInactive(filter);

		return filter;
	}

	function build(filter: Filter, rb: RequestBuilder) {
		const value = filter.value;

		if (filter.inactive || !value || !value.length) {
			return;
		}

		rb.addFilter({ field: FIELD }, rb.comparisonTypes[filter.comparisonType], value);
	}

	async function dataPromise() {
		const rb = new RequestBuilder();

		rb.addFilter({ field: 'statusCategory' }, rb.comparisonTypes.Equals, StatusCategory.Active);
		rb.extraParams.push({ key: 'country', value: countryCode });
		rb.limit = 50;

		const { data, metadata } = await Prospecting.lookup(FIELD, rb.build());
		const mappedData = data.map(({ count, [FIELD]: name }: { count: number; [FIELD]: string }) => ({
			count,
			id: name,
			name
		}));

		return { data: mappedData, metadata };
	}

	function displayText(item: { name: string; count: number }, isSelection?: boolean) {
		if (isSelection) {
			return item.name;
		}

		return `
			<div>
				${item.name}
				<div class="subtitle">
					${T('default.noOfCompanies')}: ${numberFormat(item.count)}
				</div>
			<div>
		`;
	}

	return {
		filterName: 'StockList',
		type: 'raw',
		displayType: 'list',
		title: 'prospecting.filters.stockList',
		entity: 'account',
		// The prospecting search's "Add filters" menu (CriteriaTableFooterNew) only lists filters with this set
		showOnSegment: true,
		generate,
		toUrl,
		fromUrl,
		isInactive,
		build,
		dataPromise,
		displayText
	};
}

export default generateFilter;
